import { useAuthSelector } from 'app/data/auth';
import callflowQueryKeys from 'app/hooks/queries/callflow/callflowQueryKeys';
import deviceQueryKeys from 'app/hooks/queries/device/deviceQueryKeys';
import { sdk } from 'app/sdk';
import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { DeviceUpdatePartialDoc } from 'types/device';
import { VmboxMessageUpdatePayload } from 'types/vmboxMessage';

export const useUpdateDevicePartial = () => {
  const authState = useAuthSelector();
  const queryClient = useQueryClient();
  return useMutation<any, AxiosError, DeviceUpdatePartialDoc, unknown>(
    (deviceUpdatePartialDoc: DeviceUpdatePartialDoc) =>
      sdk.device.mutate.updatePartial(
        deviceUpdatePartialDoc,
        authState?.auth_token,
      ),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(deviceQueryKeys.all);
        await queryClient.invalidateQueries(callflowQueryKeys.all);
      },
    },
  );
};
